import React, { useEffect } from 'react'
import {
  Grid,
  RadioGroup,
  FormControl,
  FormHelperText,
  FormControlLabel,
  Radio,
} from '@material-ui/core'
import { useFormContext, Controller } from 'react-hook-form'

import LegalBasisForm from './components/LegalBasisForm'
import ConsentPeopleForm from '../ConsentPeopleForm'
import ConsentForm from '../ConsentForm'

import useStyles from './styles'

const ReportSelection = ({
  setConsentForms,
  setLoadingConsentStats,
  setFields,
}) => {
  const classes = useStyles()

  const { control, watch, errors, clearError } = useFormContext()
  const reportSelected = watch('reportSelected')

  useEffect(() => {
    if (reportSelected !== 'reportByForm') {
      setFields([])
    }
  }, [reportSelected])

  return (
    <Grid item xs={12}>
      <FormControl component="fieldset" error={!!errors.reportSelected}>
        <Controller
          name="reportSelected"
          control={control}
          defaultValue=""
          as={
            <RadioGroup>
              <FormControlLabel
                value="reportByPeople"
                control={<Radio classes={{ checked: classes.checked }} />}
                className={classes.radioLabel}
                label="Relatório por pessoa"
              />
              <FormControlLabel
                value="reportByForm"
                control={<Radio classes={{ checked: classes.checked }} />}
                className={classes.radioLabel}
                label="Relatório por formulário"
              />
              <FormControlLabel
                value="reportComplete"
                control={<Radio classes={{ checked: classes.checked }} />}
                className={classes.radioLabel}
                label="Relatório completo"
              />
              <FormControlLabel
                value="reportByLegalBasis"
                control={<Radio classes={{ checked: classes.checked }} />}
                className={classes.radioLabel}
                label="Relatório por base legal"
              />
            </RadioGroup>
          }
          onChange={([e]) => {
            clearError('reportSelected')
            return e.target.value
          }}
        />
        {errors.reportSelected && (
          <FormHelperText>{errors.reportSelected.message}</FormHelperText>
        )}
      </FormControl>

      {reportSelected === 'reportByPeople' && (
        <ConsentPeopleForm
          control={control}
          watch={watch}
          errors={errors}
          clearError={clearError}
          setConsentForms={setConsentForms}
          setLoadingConsentStats={setLoadingConsentStats}
        />
      )}

      {reportSelected === 'reportByForm' && (
        <Grid item xs={12}>
          <ConsentForm
            setConsentForms={setConsentForms}
            setFields={setFields}
          />
        </Grid>
      )}
      {reportSelected === 'reportByLegalBasis' && (
        <Grid item xs={12}>
          <LegalBasisForm
            control={control}
            watch={watch}
            errors={errors}
            clearError={clearError}
            setConsentForms={setConsentForms}
          />
        </Grid>
      )}
    </Grid>
  )
}

export default ReportSelection
